import { initMercadoPago } from "@mercadopago/sdk-react";
import { StatusScreen } from "@mercadopago/sdk-react";
import { Spinner } from "react-bootstrap";
import { useState } from "react";
import { showErrorMessage } from "../../../../helpers/MessagesHelper";
const apiPublic = "TEST-238b31e5-ebb9-423e-81b7-c3ef4f00979b";
initMercadoPago(apiPublic);

function ComponentStatusScreen({ payment_key }) {
  const [isLoading, setIsLoading] = useState(true);

  const initialization = {
    paymentId: payment_key,
  };

  const customization = {
    visual: {
      style: {
        theme: "bootstrap",
      },
    },
  };

  const onError = async (error) => {
    showErrorMessage(
      error?.response?.data?.error?.statusCode,
      error?.response?.data?.error?.message
    );
  };

  const onReady = async () => {
    setIsLoading(false);
  };

  return (
    <div className="d-flex justify-content-center">
      <div className="text-center mt-5">
        {isLoading ? (
          <Spinner animation="border" role="status">
            <span className="sr-only">Carregando...</span>
          </Spinner>
        ) : (
          <div></div>
        )}
      </div>
      <StatusScreen
        initialization={initialization}
        customization={customization}
        onReady={onReady}
        onError={onError}
      />
    </div>
  );
}

export default ComponentStatusScreen;
